module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/66be91f1b84761d9f350dbf0c8844a0d.png";